<template>
  <table
    cellspacing="0"
    cellpadding="0"
    class="jin-date-table"
    @click="handleClick"
  >
    <thead>
      <tr>
        <th v-for="w in WEEKS" :key="w">
          {{ w }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(row, key) in rows"
        :key="key"
        class="jin-date-table__row"
      >
        <td
          v-for="(cell, ckey) in row"
          :key="ckey"
          :class="getCellClasses(cell)"
        >
          <div>
            <span :data-type="cell.type">
              {{ cell.text }}
            </span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
/* eslint-disable vue/require-prop-types */

import {
  getFirstDayOfMonth,
  getDayCountOfMonth,
  getDateTimestamp,
  nextDate,
  getStartDateOfMonth,
  getWeekNumber,
  getDayTimestamp
} from '@/commons/utils/date-util'

const WEEKS = ['日', '一', '二', '三', '四', '五', '六']

export default {
  name: 'JinDateTable',
  props: {
    firstDayOfWeek: {
      type: Number,
      default: 1,
      validator: val => val >= 1 && val <= 7
    },
    activeTab: String,
    date: {},
    disabledDate: {},
    selectionMode: {
      default: 'day'
    },
    daterange: {
      type: Object,
      default: () => ({
        start: '',
        end: ''
      })
    },
    initDate: {
      type: Date,
      default() {
        return this.date
      }
    },
  },
  data () {
    return {
      tableRows: [[], [], [], [], [], []]
    }
  },
  computed: {
    offsetDay () {
      const week = this.firstDayOfWeek
      // 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
      return week > 3 ? 7 - week : -week
    },
    WEEKS () {
      const week = this.firstDayOfWeek
      return WEEKS.concat(WEEKS).slice(week, week + 7)
    },
    year () {
      return this.date.getFullYear()
    },
    month () {
      return this.date.getMonth()
    },
    week () {
      return getWeekNumber(this.date)
    },
    startDate () {
      return getStartDateOfMonth(this.year, this.month)
    },
    rows () {
      const date = new Date(this.year, this.month, 1)
      let day = getFirstDayOfMonth(date)
      const dateCountOfMonth = getDayCountOfMonth(date.getFullYear(), date.getMonth())
      const dateCountOfLastMonth = getDayCountOfMonth(date.getFullYear(), (date.getMonth() === 0 ? 11 : date.getMonth() - 1))

      day = (day === 0 ? 7 : day)

      const offset = this.offsetDay
      const rows = this.tableRows
      let count = 1

      const startDate = this.startDate
      const disabledDate = this.disabledDate
      const cellClassName = this.cellClassName
      const selectedDate = this.selectionMode === 'dates' ? [this.value] : []
      const now = getDateTimestamp(new Date())

      for (let i = 0; i < 6; i++) {
        const row = rows[i]
        for (let j = 0; j < 7; j++) {
          let cell = row[j]
          if (!cell) {
            cell = { row: i, column: j, type: 'normal' }
          }

          cell.type = 'normal'

          const index = i * 7 + j
          const time = nextDate(startDate, index - offset).getTime()
          // cell.inRange = time >= getDateTimestamp(this.minDate) && time <= getDateTimestamp(this.maxDate)
          // cell.start = this.minDate && time === getDateTimestamp(this.minDate)
          // cell.end = this.maxDate && time === getDateTimestamp(this.maxDate)
          const isToday = time === now

          if (isToday) {
            cell.type = 'today'
          }

          if (i >= 0 && i <= 1) {
            const numberOfDaysFromPreviousMonth = day + offset < 0 ? 7 + day + offset : day + offset

            if (j + i * 7 >= numberOfDaysFromPreviousMonth) {
              cell.text = count++
            } else {
              cell.text = dateCountOfLastMonth - (numberOfDaysFromPreviousMonth - j % 7) + 1 + i * 7
              cell.type = 'prev-month'
            }
          } else if (count <= dateCountOfMonth) {
            cell.text = count++
          } else {
            cell.text = count++ - dateCountOfMonth
            cell.type = 'next-month'
          }

          // if (isToday) {
          //   cell.text = '今天'
          // }

          const cellDate = new Date(time)
          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate)
          cell.selected = selectedDate.find(date => date.getTime() === cellDate.getTime())
          cell.customClass = typeof cellClassName === 'function' && cellClassName(cellDate)
          this.$set(row, j, cell)
        }
      }

      return rows
    }

  },
  methods: {
    cellMatchesDate (cell, date) {
      const value = new Date(date)
      return this.year === value.getFullYear() &&
          this.month === value.getMonth() &&
          Number(cell.text) === value.getDate()
    },
    // currentPageHasDate (date) {
    //   let has = false
    //   for (let i = 0; i < this.rows.length; i++) {
    //     const cols = this.rows[i]
    //     for (let j = 0; j < cols.length; j++) {
    //       const cell = cols[i]
    //       const { row, column } = cell
    //       const cellDate = this.getDateOfCell(row, column)
    //       if (getDayTimestamp(date) === getDayTimestamp(cellDate)) {
    //         has = true
    //         break
    //       }
    //     }
    //   }
    //   return has
    // },
    getCellClasses (cell) {
      const { selectionMode } = this
      const classes = []
      const { row, column } = cell
      const newDate = this.getDateOfCell(row, column)

      if ((cell.type === 'normal' || cell.type === 'today') && !cell.disabled) {
        classes.push('avaliable')
      }
      if (selectionMode === 'day' && (cell.type === 'normal' || cell.type === 'today') && this.cellMatchesDate(cell, this.initDate)) {
        classes.push('current')
      }
      if (selectionMode === 'week') {
        const week = getWeekNumber(newDate)
        if (week === this.week) {
          classes.push('in-weekrange')
        }
        if (cell.column === 0) {
          classes.push('start-week-day')
        }
        if (cell.column === 6) {
          classes.push('end-week-day')
        }
      }
      if (selectionMode === 'range') {
        const { start, end } = this.daterange
        if (start && getDayTimestamp(newDate) === getDayTimestamp(start)) {
          classes.push('current', 'range-start')
        }
        if (end && getDayTimestamp(newDate) === getDayTimestamp(end)) {
          classes.push('current', 'range-end')
        }

        if (start && !end) {
          if (getDayTimestamp(newDate) >= getDayTimestamp(start)) {
            classes.push('in-range')
          }
        } else if (end && !start) {
          if (getDayTimestamp(newDate) <= getDayTimestamp(end)) {
            classes.push('in-range')
          }
        } else if (getDayTimestamp(newDate) >= getDayTimestamp(start) &&
          getDayTimestamp(newDate) <= getDayTimestamp(end)) {
          classes.push('in-range')
        }
      }
      if (cell.type === 'today') {
        classes.push('today')
      }
      return classes.join(' ')
    },
    handleClick (event) {
      let target = event.target
      if (target.tagName === 'SPAN') {
        target = target.parentNode.parentNode
      }
      if (target.tagName === 'DIV') {
        target = target.parentNode
      }

      if (target.tagName !== 'TD') { return }

      const row = target.parentNode.rowIndex - 1
      const column = this.selectionMode === 'week' ? 0 : target.cellIndex
      // const cell = this.rows[row][column]

      // if (cell.disabled || cell.type === 'week') { return }
      const newDate = this.getDateOfCell(row, column)

      if (this.selectionMode === 'day' || this.selectionMode === 'week') {
        this.$emit('pick', Number(newDate))
      }
      if (this.selectionMode === 'range') {
        if (this.activeTab === 'start') {
          this.$emit('start-pick', newDate)
        } else {
          this.$emit('end-pick', newDate)
        }
      }
    },
    getDateOfCell (row, column) {
      const offsetFromStart = row * 7 + column - this.offsetDay
      return nextDate(this.startDate, offsetFromStart)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/helpers/_function.scss";

.jin-date-table {
  margin: 0 auto;
  th,
  td {
    color: rgba(123, 123, 123, .6);
    border: none;
  }
  th {
    height: 28px;
    padding-bottom: 4px;
    font-size: 14px;
  }
  td {
    box-sizing: border-box;
    cursor: pointer;
    // padding: 2px 6px;
    // transition: background .3s;;
    div {
      margin: 1.5px 4px;
      height: 32px;
      span {
        display: block;
        width: 35px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        transition: background-color .3s;
        border-radius: 50%;
      }
    }
    &.avaliable {
      color: #999;
      &:hover {
        // color: $colorText
      }
    }
    &.today {
      // color: $colorText;
      span {
        font-size: 0;
        &::after {
          content: "今天";
          font-size: 14px;
        }
      }
    }
    &.current {
      &:hover {
        color: #fff;
      }
      div span {
        color: #fff;
        font-weight: bold;
        background-color: #009bbe;
        border: 1px solid #009bbe;
        border-radius: 4px;
      }

    }
    &.in-weekrange {
      background-color: $colorText;
      color: #fff;
      font-weight: bold;
      &:hover {
        color: #fff;
      }
    }
    &.in-range {
      div {
        margin-left: 0;
        margin-right: 0;
        padding-right: 4px;
        padding-left: 4px;
        background-color: #ECF1FD;
      }
      &.range-start {
        div{
          padding-left: 0;
          margin-left: 4px;
          border-top-left-radius: 28px;
          border-bottom-left-radius: 28px;
        }
      }
      &.range-end {
        div {
          padding-right: 0;
          margin-right: 4px;
          border-top-right-radius: 28px;
          border-bottom-right-radius: 28px;
        }
      }
    }
    &.start-week-day {
      border-top-left-radius: 28px;
      border-bottom-left-radius: 28px;
    }
    &.end-week-day {
      border-top-right-radius: 28px;
      border-bottom-right-radius: 28px;
    }

    @include max-screen(768px) {
      padding: 4px 0;

      &.today {
        span {
          &::after {
            font-size: 11px;
          }
        }
      }

      &.current div span {
        border-radius: 6px;
      }

      div {
        height: 28px;
        span {
          width: 28px;
          height: 28px;
          line-height: 28px;
          text-align: center;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// JinDateTable.vue?15572ce6